module.exports = __webpack_public_path__ + "img/left-leg.b014b6d9.png";